<!-- Start Hero -->
<section class="relative table w-full py-36 bg-[url('/assets/images/parallax/archer_1920x1200.jpg')] bg-center bg-no-repeat">
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center mt-10">
      <h3 class="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">{{ 'CONQUER_VIP.TITLE' | translate }}</h3>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->
<div class="relative">
  <div class="shape absolute start-0 end-0 sm:-bottom-px -bottom-[2px] overflow-hidden z-1 text-white dark:text-slate-900">
    <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!-- End Hero -->

<section class="relative md:pt-24 py-8">
  <div class="container">
    <!-- Loading indicator -->
    <div class="grid md:grid-cols-12 gap-[30px]">
      <!-- VIP Binding Form -->
      <div class="lg:col-span-6 md:col-span-6">
        <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
          <h5 class="text-lg font-semibold mb-4">{{ 'CONQUER_VIP.BIND.TITLE' | translate }}</h5>

          <form [formGroup]="bindForm" (ngSubmit)="bindVipAccount()" *ngIf="vipInfo && vipInfo.vipBindNum < vipInfo.vipBindLimit">
            <div class="mb-4">
              <label class="font-semibold" for="userName">{{ 'CONQUER_VIP.BIND.USERNAME' | translate }}</label>
              <input id="userName" type="text" formControlName="userName"
                     class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0"
                     placeholder="{{ 'CONQUER_VIP.BIND.USERNAME_PLACEHOLDER' | translate }}">
              <div *ngIf="bindForm.get('userName')?.invalid && bindForm.get('userName')?.touched" class="text-red-500 mt-1 text-sm">
                {{ 'CONQUER_VIP.BIND.ERRORS.USERNAME_REQUIRED' | translate }}
              </div>
            </div>

            <!-- Backend error message -->
            <div *ngIf="bindError" class="mb-4 p-3 bg-red-50 text-red-700 rounded-md dark:bg-red-900/20 dark:text-red-400">
              <p class="text-sm font-medium">{{ bindError }}</p>
            </div>

            <app-button
              type="submit"
              [disabled]="bindForm.invalid"
              [loading]="bindLoading"
              [fullWidth]="true"
              color="primary">
              {{ 'CONQUER_VIP.BIND.SUBMIT' | translate }}
            </app-button>
          </form>

          <!-- VIP Rules -->
          <div class="mt-6">
            <h6 class="font-semibold mb-2">{{ 'CONQUER_VIP.RULES.TITLE' | translate }}</h6>
            <ul class="list-disc pl-5 space-y-2 text-slate-400">
              <li *ngFor="let rule of vipRules">{{ rule | translate }}</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- VIP Info and Bindings -->
      <div class="lg:col-span-6 md:col-span-6">
        <div class="mb-4" *ngIf="loading">
          <app-loading />
        </div>
        <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900" *ngIf="!loading">
          <h5 class="text-lg font-semibold mb-4">{{ 'CONQUER_VIP.INFO.TITLE' | translate }}</h5>

          <div *ngIf="vipInfo">
            <div class="grid grid-cols-2 gap-4 mb-6">
              <div>
                <p class="text-slate-400">{{ 'CONQUER_VIP.INFO.VIP_LEVEL' | translate }}</p>
                <p class="font-semibold">{{ vipInfo.vipLevel }}</p>
              </div>
              <div>
                <p class="text-slate-400">{{ 'CONQUER_VIP.INFO.VIP_POINTS' | translate }}</p>
                <p class="font-semibold">{{ vipInfo.vipPoint }} / {{ vipInfo.vipPointNext }}</p>
              </div>
              <div>
                <p class="text-slate-400">{{ 'CONQUER_VIP.INFO.BIND_COUNT' | translate }}</p>
                <p class="font-semibold">{{ vipInfo.vipBindNum }}</p>
              </div>
              <div>
                <p class="text-slate-400">{{ 'CONQUER_VIP.INFO.BIND_LIMIT' | translate }}</p>
                <p class="font-semibold">{{ vipInfo.vipBindLimit }}</p>
              </div>
            </div>

            <!-- Bindings List -->
            <h6 class="font-semibold mb-2">{{ 'CONQUER_VIP.BINDINGS.TITLE' | translate }}</h6>

            <div *ngIf="vipInfo.bindings && vipInfo.bindings.length > 0">
              <div *ngFor="let binding of vipInfo.bindings" class="p-4 border border-gray-200 dark:border-gray-700 rounded-md mb-3">
                <div class="flex justify-between items-center">
                  <div>
                    <p class="font-semibold">{{ binding.userName }}</p>
                    <p class="text-sm text-slate-400">{{ 'CONQUER_VIP.BINDINGS.BIND_DATE' | translate }}: {{ binding.bindDate | date: 'yyyy-MM-dd HH:mm' }}</p>
                  </div>
                  <div *ngIf="binding.allowUnbind">
                    <app-button
                      (buttonClick)="openUnbindModal(binding)"
                      color="danger"
                      size="small">
                      {{ 'CONQUER_VIP.BINDINGS.UNBIND' | translate }}
                    </app-button>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="!vipInfo.bindings || vipInfo.bindings.length === 0" class="text-center py-4 text-slate-400">
              {{ 'CONQUER_VIP.BINDINGS.NO_BINDINGS' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Unbind Modal -->
<div [ngClass]="showUnbindModal ? '' : 'hidden'" class="fixed z-50 overflow-hidden inset-0 m-auto flex items-center justify-center w-full h-[100vh]" style="background-color: #000000a1;">
  <div class="relative w-full h-auto max-w-md p-4">
    <div class="relative bg-white dark:bg-slate-900 rounded-lg shadow dark:shadow-gray-800">
      <div class="flex justify-between items-center px-6 py-4 border-b border-gray-100 dark:border-gray-700">
        <h5 class="text-xl font-semibold">{{ 'CONQUER_VIP.MODALS.UNBIND.TITLE' | translate }}</h5>
        <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ms-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" (click)="closeUnbindModal()">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
        </button>
      </div>
      <div class="p-6">
        <div class="grid grid-cols-1">
          <div class="mb-4">
            <div class="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-red-900/20 dark:text-red-400" role="alert">
              <span class="font-medium">{{ 'CONQUER_VIP.MODALS.UNBIND.WARNING' | translate }}</span>
            </div>
            <p class="mb-2">{{ 'CONQUER_VIP.MODALS.UNBIND.CONFIRMATION_TEXT' | translate }}</p>
            <p class="font-semibold">{{ selectedBinding?.userName }}</p>
          </div>

          <!-- Backend error message -->
          <div *ngIf="unbindError" class="mb-4 p-3 bg-red-50 text-red-700 rounded-md dark:bg-red-900/20 dark:text-red-400">
            <p class="text-sm font-medium">{{ unbindError }}</p>
          </div>

          <div class="flex justify-end space-x-3">
            <app-button
              (buttonClick)="closeUnbindModal()"
              color="secondary"
              rounded="full">
              {{ 'CONQUER_VIP.MODALS.UNBIND.CANCEL' | translate }}
            </app-button>
            <app-button
              (buttonClick)="unbindVipAccount()"
              [loading]="unbindLoading"
              color="danger"
              rounded="full">
              {{ 'CONQUER_VIP.MODALS.UNBIND.SUBMIT' | translate }}
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Unbind Modal -->
